export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_Md.37b5c7a6.ttf";